module.exports = __webpack_public_path__ + "img/t5-i5.e2630a1a.svg";